import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import styles from './OutputWeergave.module.css';

const OUTPUT_LABELS = {
  sbar:              'SBAR',
  artsconsult:       'Artsconsult',
  rapportage:        'Verpleegkundige Rapportage',
  dienst_overdracht: 'Dienst-overdracht',
  familie:           'Familiecommunicatie',
  overplaatsing:     'Overplaatsingsoverdracht',
};

const SBAR_KLEUREN = {
  S: { bg: '#EEEEFF', rand: '#2D2B6B', label: 'Situation', sub: 'Huidige situatie' },
  B: { bg: '#EEF2FF', rand: '#3B5FC0', label: 'Background', sub: 'Achtergrond' },
  A: { bg: '#FFF8E6', rand: '#C65A00', label: 'Assessment', sub: 'Beoordeling' },
  R: { bg: '#F0FBF4', rand: '#1A6B3C', label: 'Recommendation', sub: 'Aanbeveling' },
};

export default function OutputWeergave({ outputData, sessieId, onNieuweBeoordeling, onTweedeOutput }) {
  const navigate = useNavigate();
  const [laden, setLaden]               = useState(false);
  const [tweedeOutputLaden, setTweede]  = useState(false);
  const [gekopieerd, setGekopieerd]     = useState(false);
  const [tweedeType, setTweedeType]     = useState('');
  const [toonTweedeKeuze, setToonTweede] = useState(false);

  if (!outputData) return null;

  const { output_id, output_type, inhoud } = outputData;

  // Probeer JSON te parsen voor SBAR-weergave (alleen SBAR)
  let sbarData = null;
  if (output_type === 'sbar') {
    try {
      const data = typeof inhoud === 'object'
        ? inhoud
        : JSON.parse(inhoud.replace(/```json\n?|\n?```/g, '').trim());
      sbarData = data;
    } catch {}
  }

  function renderMarkdown(tekst) {
    if (!tekst) return null;
    const str = typeof tekst === 'string' ? tekst : JSON.stringify(tekst, null, 2);
    const cleaned = str.replace(/```[\w]*\n?|\n?```/g, '').trim();
    const lines = cleaned.split('\n');
    const elements = [];
    let i = 0;
    while (i < lines.length) {
      const line = lines[i];
      if (!line.trim()) { elements.push(<br key={i} />); i++; continue; }
      if (line.trim().match(/^\*\*.*\*\*$/)) {
        elements.push(<h3 key={i} style={{fontSize:15,fontWeight:700,color:'#2D2B6B',margin:'16px 0 6px',paddingBottom:4,borderBottom:'1px solid #E0E7F0',fontFamily:'Arial'}}>{line.trim().replace(/\*\*/g,'')}</h3>);
      } else if (line.trim().match(/^[-*]\s/)) {
        const item = line.trim().replace(/^[-*]\s/,'');
        const parts = item.split(/\*\*(.*?)\*\*/g);
        elements.push(<div key={i} style={{display:'flex',gap:8,fontSize:14,color:'#1A1A2E',lineHeight:1.6,marginBottom:4,fontFamily:'Arial'}}><span style={{color:'#3B5FC0',fontWeight:700}}>•</span><span>{parts.map((p,j)=>j%2===1?<strong key={j}>{p}</strong>:p)}</span></div>);
      } else if (line.trim().match(/^\d+\.\s/)) {
        const match = line.trim().match(/^(\d+)\.\s(.*)$/);
        elements.push(<div key={i} style={{display:'flex',gap:8,fontSize:14,color:'#1A1A2E',lineHeight:1.6,marginBottom:4,fontFamily:'Arial'}}><span style={{color:'#3B5FC0',fontWeight:700,minWidth:20}}>{match[1]}.</span><span>{match[2]}</span></div>);
      } else {
        const parts = line.split(/\*\*(.*?)\*\*/g);
        elements.push(<p key={i} style={{fontSize:14,color:'#1A1A2E',lineHeight:1.6,margin:'0 0 8px',fontFamily:'Arial'}}>{parts.map((p,j)=>j%2===1?<strong key={j}>{p}</strong>:p)}</p>);
      }
      i++;
    }
    return elements;
  }

  async function handleKopieer() {
    try {
      const LABELS = { S:'Situation', B:'Background', A:'Assessment', R:'Recommendation' };
      let tekstPlain, tekstHtml;
      if (output_type === 'sbar' && sbarData) {
        tekstPlain = Object.entries(sbarData).map(([k,v])=>`${k} — ${LABELS[k]||k}:\n${v}`).join('\n\n');
        tekstHtml  = Object.entries(sbarData).map(([k,v])=>`<h3 style="color:#2D2B6B">${k} — ${LABELS[k]||k}</h3><p>${v}</p>`).join('');
      } else {
        const str = typeof inhoud === 'string' ? inhoud : JSON.stringify(inhoud, null, 2);
        tekstPlain = str.replace(/```[\w]*\n?|\n?```/g,'').replace(/\*\*/g,'').trim();
        tekstHtml  = str.replace(/```[\w]*\n?|\n?```/g,'').trim().split('\n').map(line => {
          if (!line.trim()) return '<br>';
          if (line.trim().match(/^\*\*.*\*\*$/)) return `<h3 style="color:#2D2B6B;margin:12px 0 4px">${line.trim().replace(/\*\*/g,'')}</h3>`;
          if (line.trim().match(/^[-*]\s/)) return `<p style="margin:2px 0 2px 16px">• ${line.trim().replace(/^[-*]\s/,'').replace(/\*\*(.*?)\*\*/g,'<strong>$1</strong>')}</p>`;
          if (line.trim().match(/^\d+\.\s/)) return `<p style="margin:2px 0 2px 16px">${line.trim()}</p>`;
          return `<p style="margin:0 0 6px">${line.replace(/\*\*(.*?)\*\*/g,'<strong>$1</strong>')}</p>`;
        }).join('');
      }
      try {
        await navigator.clipboard.write([new ClipboardItem({'text/plain':new Blob([tekstPlain],{type:'text/plain'}),'text/html':new Blob([tekstHtml],{type:'text/html'})})]);
      } catch { await navigator.clipboard.writeText(tekstPlain); }
      setGekopieerd(true);
      toast.success('Gekopieerd naar klembord.');
      setTimeout(() => setGekopieerd(false), 3000);
    } catch {
      toast.error('Kopiëren mislukt. Selecteer de tekst handmatig.');
    }
  }

  async function handlePDF() {
    if (!output_id) return toast.error('Sla de output eerst op.');
    setLaden(true);
    try {
      const res = await axios.get(`/api/outputs/${output_id}/pdf`, { responseType: 'blob' });
      const url = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      const a   = document.createElement('a');
      a.href    = url;
      a.download = `alyden-${output_type}-${new Date().toISOString().slice(0,10)}.pdf`;
      a.click();
      URL.revokeObjectURL(url);
      toast.success('PDF gedownload.');
    } catch {
      toast.error('PDF genereren mislukt.');
    } finally {
      setLaden(false);
    }
  }

  async function handleTweedeOutput() {
    if (!tweedeType) return toast.error('Kies een outputtype.');
    setTweede(true);
    try {
      await onTweedeOutput(tweedeType);
      setToonTweede(false);
      setTweedeType('');
    } finally {
      setTweede(false);
    }
  }

  return (
    <div className={styles.pagina}>

      {/* Header */}
      <div className={styles.header}>
        <div>
          <h2 className={styles.titel}>{OUTPUT_LABELS[output_type] || output_type}</h2>
          <p className={styles.subtitel}>Gegenereerd op {new Date().toLocaleString('nl-NL')}</p>
        </div>
        <div className={styles.acties}>
          <button className={styles.knopSecundair} onClick={handleKopieer} disabled={gekopieerd}>
            {gekopieerd ? '✓ Gekopieerd' : '📋 Kopiëren'}
          </button>
          <button className={styles.knopSecundair} onClick={handlePDF} disabled={laden}>
            {laden ? 'Laden...' : '📄 PDF'}
          </button>
        </div>
      </div>

      {/* SBAR weergave (met S/B/A/R kaarten) */}
      {sbarData ? (
        <div className={styles.sbarWrap}>
          {['S', 'B', 'A', 'R'].map(letter => {
            if (!sbarData[letter]) return null;
            const k = SBAR_KLEUREN[letter];
            return (
              <div key={letter} className={styles.sbarKaart} style={{ borderLeftColor: k.rand, background: k.bg }}>
                <div className={styles.sbarHeader}>
                  <div className={styles.sbarBadge} style={{ background: k.rand }}>{letter}</div>
                  <div>
                    <div className={styles.sbarLabel}>{k.label}</div>
                    <div className={styles.sbarSub}>{k.sub}</div>
                  </div>
                </div>
                <div className={styles.sbarTekst}>{sbarData[letter]}</div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className={styles.tekstWrap}>
          {renderMarkdown(inhoud)}
        </div>
      )}

      {/* Link naar Mijn outputs voor extra output */}
      <div className={styles.tweedeWrap}>
        <p className={styles.tweedeTitel}>Wil je een ander outputtype genereren vanuit dezelfde gegevens?</p>
        <button className={styles.knopTweede} onClick={() => navigate('/outputs')}>
          📋 Bekijk en beheer outputs in Mijn outputs
        </button>
      </div>

      {/* Nieuwe beoordeling starten */}
      <button className={styles.nieuwKnop} onClick={onNieuweBeoordeling}>
        ↺ Nieuwe beoordeling starten
      </button>

    </div>
  );
}
